module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("20MGC"))).then(() => parcelRequire('d0iPb'));